export default __webpack_public_path__ + "static/media/pexels-karolina-grabowska-6214835-min-min.a0e2a739.jpg";